module.exports = __webpack_public_path__ + "static/media/024.1be91c66.jpg";